"use client";
import React from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { BASE_URL } from "@/constants";
import { createSession } from "@/app/[locale]/auth/session";

const MyGoogleSigninButton = () => {
  const handleSuccess = async (credentialResponse) => {
    try {
      const body = {
        token: credentialResponse.credential,
      };

      // Send the token to your backend to create a session
      const resp = await axios.post(BASE_URL + "user-auth/google", body);
      const data = resp.data;
      await createSession(data);

      window.location.href = `/`;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleError = () => {
    console.error("Google Sign-In Error");
  };

  return (
    <GoogleOAuthProvider clientId="878607249618-9tthcc72lvsssdbkivbbvu9cg5m36c67.apps.googleusercontent.com">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        type={'icon'}
        size={'large'}
        shape={'rectangular'}
        width="400"
      />
    </GoogleOAuthProvider>
  );
};

export default MyGoogleSigninButton;
